import React from 'react';
import classnames from 'classnames';
import { getBackgroundColorClassName } from 'src/components/Header/utils/Header';
import wrapperStyles from 'src/components/Layout/Wrapper.scss';
import { NavBackgroundColor } from 'src/types/global-types';

import { CurrencySelect } from '../StoreControls/CurrencySelect';
import { VatSelect } from '../StoreControls/VatSelect';

import classes from './HeaderStore.scss';

type Props = NavBackgroundColor;

export const HeaderStore: React.FC<Props> = ({ bg, className, whiteIcons }) => {
    return (
        <div className={classnames([classes.headerStore, className])}>
            <ul className={classes.headerStoreList}>
                <li
                    className={classnames([classes.headerStoreItem].join(' '), {
                        ...getBackgroundColorClassName(wrapperStyles, bg),
                    })}
                >
                    <CurrencySelect whiteIcons={whiteIcons ?? false} />
                </li>
                <li
                    className={classnames([classes.headerStoreItem].join(' '), {
                        ...getBackgroundColorClassName(wrapperStyles, bg),
                    })}
                >
                    <VatSelect />
                </li>
                {/* GeoFlag */}
                {/* <li
                    className={classnames([classes.headerStoreItem].join(' '), {
                        ...getBackgroundColorClassName(wrapperStyles, bg),
                    })}
                >
                    <GeoFlag />
                </li> */}
            </ul>
        </div>
    );
};
